const addMinutes = (date: Date, minutes: number): any => {
    return new Date(date.getTime() + minutes*60000);
};
export default addMinutes;
  